import React from "react";

import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
	const sessionStorageToken = sessionStorage.getItem("token");

	return sessionStorageToken ? <Outlet /> : <Navigate to="/"  replace />;
};

export default ProtectedRoutes;